module.exports = __webpack_public_path__ + "img/av_lion.4b529348.png";